import Repository from './Repository'
const resource = '/settings'

export default {
  /**
   * パスワードを登録する
   * @param {String} password パスワード
   */
  async postPassword(password) {
    const params = { chief_password: password }
    return await Repository.post(`${resource}/b_list/permissions/chief_password`, params)
      .then(response => {
        return response
      })
      .catch(e => {
        console.log(e)
        return e.response
      })
  },
  /**
   * パスワードを更新する
   * @param {String} oldPassword 旧パスワード
   * @param {String} newPassword 新パスワード
   */
  async putPassword(oldPassword, newPassword) {
    const params = { old_chief_password: oldPassword, new_chief_password: newPassword }
    return await Repository.put(`${resource}/b_list/permissions/chief_password`, params)
      .then(response => {
        return response
      })
      .catch(e => {
        console.log(e)
        return e.response
      })
  },
  /**
   * パスワード認証
   * @param {String} password パスワード
   */
  async authPassword(password) {
    const params = { chief_password: password }
    return await Repository.post(`${resource}/b_list/permissions/chief_password/_auth`, params)
      .then(response => {
        return response
      })
      .catch(e => {
        console.log(e)
        return e.response
      })
  },
  /**
   * 管理者設定を取得する
   */
  async getPermissions() {
    return await Repository.get(`${resource}/b_list/permissions`)
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
  /**
   * 管理者設定を更新する
   * @param {Object} permissions 管理者設定情報
   */
  async putPermissions(permissions) {
    const params = permissions
    return await Repository.put(`${resource}/b_list/permissions`, params)
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
  /**
   * コンバート指示設定を取得する
   * @param {String} type 物件種別 residence:居住用 investment:事業・投資用
   */
  async getConvertInstructions(type) {
    const params = { type: type }
    return await Repository.get(`${resource}/b_list/convert/instructions`, { params: params })
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
  /**
   * コンバート指示設定を更新する
   * @param {Array} instructions コンバート指示設定
   * @param {String} type 物件種別 residence:居住用 investment:事業・投資用
   */
  async putConvertInstructions(instructions, type) {
    const params = { instructions: instructions, type: type }
    return await Repository.put(`${resource}/b_list/convert/instructions`, params)
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
  /**
   * コンバート物件名表示設定を取得する
   * @param {String} type 物件種別 residence:居住用 investment:事業・投資用
   */
  async getConvertDisplays(type) {
    const params = { type: type }
    return await Repository.get(`${resource}/b_list/convert/b_name_displays`, { params: params })
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
  /**
   * コンバート物件名表示設定を更新する
   * @param {Array} displays コンバート物件名表示設定
   * @param {String} type 物件種別 residence:居住用 investment:事業・投資用
   */
  async putConvertDisplays(displays, type) {
    const params = { displays: displays, type: type }
    return await Repository.put(`${resource}/b_list/convert/b_name_displays`, params)
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
  /**
   * 物件一覧の表示項目（一覧テーブルのカラム）設定を取得する
   * @param {String} type 物件種別 residence:居住用 investment:事業・投資用
   */
  async getColumns(type) {
    const params = { type: type }
    return await Repository.get(`${resource}/b_list/columns`, { params: params })
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
  /**
   * 物件一覧の表示項目（一覧テーブルのカラム）設定を更新する
   * @param {Array} columns カラム設定
   * @param {String} type 物件種別 residence:居住用 investment:事業・投資用
   */
  async putColumns(columns, type) {
    const params = { columns: columns, type: type }
    return await Repository.put(`${resource}/b_list/columns`, params)
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
  /**
   * 沿線リストを取得する
   * @param {Array} prefCds 都道府県コード
   */
  async getLines(prefCds) {
    const params = { pref_cds: prefCds }
    return await Repository.get(`${resource}/lines`, { params: params })
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
}
